/**
 * Maps trigger/action kebab-case IDs to display categories.
 * Prefix-based matching — first match wins.
 */
const CATEGORY_PREFIXES: [string, string][] = [
  // Blockchain
  ["evm-log", "Blockchain"],
  ["erc20-", "Blockchain"],
  ["send-erc20-", "Blockchain"],
  ["send-native-", "Blockchain"],
  // DeFi
  ["v2-", "DeFi"],
  ["v3-", "DeFi"],
  ["v4-", "DeFi"],
  ["relay-swap", "DeFi"],
  ["add-liquidity", "DeFi"],
  ["remove-liquidity", "DeFi"],
  // Polymarket
  ["polymarket-", "Polymarket"],
  // Messaging
  ["slack-", "Messaging"],
  ["send-slack-", "Messaging"],
  ["send-discord-", "Messaging"],
  ["discord-", "Messaging"],
  // Email
  ["email-", "Email"],
  ["gmail-", "Email"],
  // Shopify
  ["shopify-", "Shopify"],
  // Social
  ["post-farcaster-", "Social"],
  ["search-twitter-", "Social"],
  // AI & Compute
  ["openrouter-", "AI & Compute"],
];

/** Known abbreviations to preserve in Title Case conversion. */
const ABBREVIATIONS: Record<string, string> = {
  erc20: "ERC20",
  evm: "EVM",
  v2: "V2",
  v3: "V3",
  v4: "V4",
  ai: "AI",
  api: "API",
  nft: "NFT",
  http: "HTTP",
};

export function getCategory(id: string): string {
  for (const [prefix, category] of CATEGORY_PREFIXES) {
    if (id === prefix || id.startsWith(prefix)) return category;
  }
  return "General";
}

export function humanizeName(id: string): string {
  return id
    .split("-")
    .map(word => ABBREVIATIONS[word] ?? word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/** Order categories should appear in the UI. */
export const CATEGORY_ORDER = [
  "Blockchain",
  "DeFi",
  "Polymarket",
  "Messaging",
  "Email",
  "Shopify",
  "Social",
  "AI & Compute",
  "General",
];
